// packages
import { Navbar, Nav, Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
// components
import PNPLogo from '../../../assets/PNPLogo/PNPLogo';
import { useState } from 'react';
import LoginModal from './LoginModal';
// api

// styles
import './TopbarLP.scss';

const TopbarLP = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // login handler
  const signInHandler = (e) => {
    e.preventDefault();
  };
  return (
    <>
      <div className='topbarLP '>
        <div className='container'>
          <Navbar expand='md'>
            <PNPLogo />
            <Navbar.Toggle
              className='mt-2 ms-auto'
              aria-controls='basic-navbar-nav'
            />
            <Navbar.Collapse id='basic-navbar-nav'>
              <Nav
                className='ms-4'
                onSelect={(selectedKey) => console.log(selectedKey)}
              >
                <Nav.Item>
                  <NavLink
                    to='/'
                    eventKey='home'
                  >
                    Home
                    <p className='line'></p>
                  </NavLink>
                </Nav.Item>
                <Nav.Item>
                  <NavLink
                    to='/courses'
                    eventKey='courses'
                  >
                    Courses
                    <p className='line'></p>
                  </NavLink>
                </Nav.Item>

                <Nav.Item>
                  <NavLink
                    to='/contact-us'
                    eventKey='contact-us'
                  >
                    Contact Us
                    <p className='line'></p>
                  </NavLink>
                </Nav.Item>
              </Nav>
              <Button
                className='m-0 ms-auto'
                variant='add'
              >
                <span
                  className='px-3 py-2 '
                  onClick={handleShow}
                >
                  Login
                </span>
              </Button>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>
      <LoginModal
        handleClose={handleClose}
        handleShow={handleShow}
        show={show}
        signInHandler={signInHandler}
      />
    </>
  );
};

export default TopbarLP;
